import { Component, OnInit,QueryList, ViewChildren } from '@angular/core';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';
import {
  Platform,
  Config,
  ModalController,
  MenuController,
  ActionSheetController,
  PopoverController,
  IonRouterOutlet,
  ToastController,
  Events
} from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from 'ionic-cache';
import { Storage } from '@ionic/storage';
import { formatDate, DatePipe } from '@angular/common';
import { Location } from '@angular/common';
import { Device } from '@ionic-native/device/ngx';



import { Localizzazione } from './models/localizzazione';
import Auth0Cordova from '@auth0/cordova';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { AuthService } from './services/auth.service';
import * as Constants from 'src/app/app.constants';
import { AnalyticsService } from './analytics.service';
import { Title } from '@angular/platform-browser';

import { v4 as uuidv4 } from 'uuid';
import { v5 as uuidv5 } from 'uuid';
import { MultiTenantService } from './services/multi-tenant.service';

import { Page, PageChild } from 'src/app/models/page';



@Component({
  selector: 'app-root',
  template: `
    <ion-app class="ionApp {{ isDesktop ? 'isDesktop' : 'isMobile' }}">
      <ion-split-pane disabled="true">
        <ion-menu>
          <ion-header>
            <ion-toolbar color="primary">
              <ion-title>Menu</ion-title>
            </ion-toolbar>
          </ion-header>

          <ion-content>

            <ion-list *ngIf="appPages">

            <div *ngFor="let p of appPages">

              <ion-menu-toggle auto-hide="false" *ngIf="p.url">
                <ion-item
                  *ngIf="p.isVisible"
                  [routerDirection]="'root'"
                  [routerLink]="[p.url]"
                >
                  <ion-icon slot="start" [name]="p.icon"></ion-icon>
                  <ion-label>
                    {{ p.title | translate }}
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>

              <ion-item button *ngIf="p.child?.length>0" (click) = "p.open = !p.open"
              [class.active-parent] = "p.open" detail = "false">
              <ion-icon slot="start" [name]="p.iconOpen" *ngIf='p.open'></ion-icon>
              <ion-icon slot="start" [name]="p.iconClose" *ngIf='!p.open'></ion-icon>
                <ion-label>
                    {{ p.title | translate }}
                </ion-label>

              </ion-item>

              <ion-list *ngIf="p.open">

              <ion-menu-toggle auto-hide="false">
              <ion-item
                class="sub-item"
                *ngFor="let sub of p.child"
                [routerDirection]="'root'"
                [routerLink]="[sub.url]"
              >
                <ion-icon slot="start" [name]="sub.icon"></ion-icon>
                <ion-label>
                  {{ sub.title | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>

              </ion-list>


              </div>
            </ion-list>
          </ion-content>
        </ion-menu>
        <ion-router-outlet main></ion-router-outlet>
      </ion-split-pane>
    </ion-app>
  `
})
export class AppComponent implements OnInit {
  gpsSecondsAgo: number = 0;
  
  public appPages: Array<Page>;

  @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;
  @ViewChildren(IonRouterOutlet) routerOutlet: IonRouterOutlet;
  lastTimeBackPress = 0;
  timePeriodToExit = 2000;
  isDesktop: boolean;


  

  constructor(
    cache: CacheService,
    private multiTenantService: MultiTenantService,

    private analyticsService: AnalyticsService,
    public router: Router,
    private titleService: Title,
    public ga: GoogleAnalytics,
    private translate: TranslateService,
    private platform: Platform,    
    public device: Device, 
    private storage:Storage,

    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private config: Config,
    public auth: AuthService,
    public modalCtrl: ModalController,
    public toastController: ToastController,
    public location: Location

  ) {

    //console.log('App Component');




    translate.addLangs(['en', 'it']);

    if (this.platform.is('desktop')) {
      this.isDesktop = true;
    } else {
      this.isDesktop = false;
    }

  }

  ngOnInit() {
    //console.log( 'App Component ngOnInit');

    //Questa chiamata viene fatta isolata perchè per un momento anche se breve, viene cambiata la lingua
    this.multiTenantService.getUserLanguage().then(result => {

      //console.log( 'App Component ngOnInit - Promise All');

      Promise.all([

        this.analyticsService.initializeService(),
        this.multiTenantService.getCity(),
        this.multiTenantService.getTags(),
        this.multiTenantService.getAppPages()
        
  
  
      ]).then(res => {
        //console.log('App Component Then');
      }, err => {
        //console.log('App Component ERR');
      }  ).finally( () => {
        //console.log('App Component Final');
        this.appPages = this.multiTenantService.appPages
        this.createAppPages();
        this.initializeApp();
      }
      ); 

    });



  }


  
  createAppPages() {

    //console.log('AUTH - SUBSCRIBE - PREAPP - App.component - createAppPages');

    this.auth.isAuthenticatedObs().subscribe( isAuth => {
      //console.log('AUTH - SUBSCRIBE - App.component');
      let isLoggedIn = isAuth;

      const loginlink = {
        title: 'Login',
        url: '/login',
        icon: 'home',
        isVisible: !isLoggedIn
      };
  
      const logoutlink = {
        title: 'Logout',
        url: '/logout',
        icon: 'log-out',
        isVisible: isLoggedIn
      };
  
      const profileLink = {
        title: 'PROFILE_TITLE',
        url: '/profile',
        icon: 'person',
        isVisible: isLoggedIn
      };
  
      if ( this.auth.isAuthenticated() ) {
        isLoggedIn = true;
      } else {
        isLoggedIn = false;
      }

      if ( this.appPages ) {
          
        const indexLogin = this.appPages.findIndex(
          x => x.url === loginlink.url
        );
        if (indexLogin !== -1) {
          this.appPages[indexLogin].isVisible = !isLoggedIn;
        }
    
        const indexLogout = this.appPages.findIndex(
          x => x.url === logoutlink.url
        );
        if (indexLogout !== -1) {
          this.appPages[indexLogout].isVisible = isLoggedIn;
        }
    
        const indexProfile = this.appPages.findIndex(
          x => x.url === profileLink.url
        );
        if (indexProfile !== -1) {
          this.appPages[indexProfile].isVisible = isLoggedIn;
        }
      }
 

    } );

  

  }

  

  public setTitle( newTitle: string) {
    this.titleService.setTitle( newTitle );
  }




   

  initializeApp() {
    //console.log('ANALYTICS - initializeApp');

    this.platform.ready().then(() => {


      //Inizializzazione dei servizi di Analytics
      this.analyticsService.initialize();

      let title = "_";
      this.analyticsService.sendPage( title, this.location.path(false) );
      
      this.analyticsService.addLocalNavigation( this.location.path(false) );

      this.router.events.subscribe(event => {

        //observe router and when it start navigation it will track the view
        if (event instanceof NavigationEnd) {

          /**
           * il title viene aggiornato con la versione internazionalizzata, 
           * ma qui c'è ancora la vecchia versione
           */
          

 
          let title = this.titleService.getTitle();
          //console.log(title);



          /**

          */

          /*
          L'invio ad Analytics lo facciamo senza il title dinamico, perchè il sendPage
          viene inviato prima che venga cambiato il TITLE della Pagina.
          Se abbiamo necessità di inviare il SendPage con il title della pagina, occorre
          cambiare questa logica.
          */
         

          /**
           * Rettifica al commento precedente!!!
           * Ho recuperato il title dell'oggetto che andrò a visitare, nel metodo - apriPaginaDettaglio
           */
          let currentNavigation = this.router.getCurrentNavigation();
          if (currentNavigation.extras.state && currentNavigation.extras.state.nameNextElement) {
            title = currentNavigation.extras.state.nameNextElement;
          }

          this.analyticsService.sendPage( title,  event.url);
          this.analyticsService.addLocalNavigation( event.url );
        }
      });





      
      this.statusBar.overlaysWebView(false);

      // set status bar to white
      this.statusBar.backgroundColorByHexString('#184fa4');
      this.splashScreen.hide();

      try {
        (<any>window).handleOpenURL = url => {
          Auth0Cordova.onRedirectUri(url);
        };
      } catch (error) {
        console.error(`Chiudi tutte le finestre del browser: ${error}`);
      }
    });

    //this.initTranslate();
  }

  initTranslate() {
    // Set the default language for translation strings, and the current language.

    const browserLang = this.translate.getBrowserLang();

    if (browserLang) {
      if (browserLang === 'zh') {
        const browserCultureLang = this.translate.getBrowserCultureLang();

        if (browserCultureLang.match(/-CN|CHS|Hans/i)) {
          this.translate.use('zh-cmn-Hans');
        } else if (browserCultureLang.match(/-TW|CHT|Hant/i)) {
          this.translate.use('zh-cmn-Hant');
        }
      } else {

      }
    } else {

    }

    this.translate.get(['BACK_BUTTON_TEXT']).subscribe(values => {
      // this.config.set('ios', 'backButtonText', values.BACK_BUTTON_TEXT);
      const text = this.config.get('backButtonText');
      this.config.set('backButtonIcon', values.BACK_BUTTON_TEXT);
    });
  }
}
